// only keys holding a string value can be used to display an option
type OptionKey<OptionType> = keyof OptionType &
  {
    [Key in keyof OptionType]: OptionType[Key] extends string ? Key : never;
  }[keyof OptionType];

export default function ListSelection<OptionType>({
  idKey,
  renderLabel,
  options,
  onSelect,
  countKey,
  renderIcon,
}: {
  idKey: OptionKey<OptionType>;
  renderLabel: (option: OptionType) => string;
  options: OptionType[];
  onSelect: (selectedOption: OptionType) => void;
  countKey?: keyof OptionType;
  renderIcon?: (option: OptionType) => JSX.Element;
}) {
  return (
    <div className="flex max-h-[216px] flex-col overflow-y-auto scrollbar-thin">
      {options.map((option) => {
        const count = countKey ? (option[countKey] as string | number) : null;
        const label = renderLabel(option);

        return (
          <button
            type="button"
            className="group flex py-1.5 min-h-8 shrink-0 items-center gap-x-1.5 rounded-xl px-1.5 hover:bg-black-100 disabled:cursor-not-allowed disabled:text-black-400 disabled:hover:bg-transparent"
            key={option[idKey].toString()}
            onClick={() => onSelect(option)}
            title={label}
          >
            {renderIcon?.(option)}
            <span className="line-clamp-1 flex-1 text-left text-button-xs">
              {label}
            </span>
            {!!count && (
              <span className="text-xs text-black-500 group-disabled:text-black-400">
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
